import { Button, Form, Grid, Popup, Text, TextField } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';
import { useForm } from 'react-hook-form';

import { isLoading, requestSelector } from '../../selectors/pageSelectors';
import { commentFieldName } from './ResubmitRequestPopupContent.constants';
import { messages } from './ResubmitRequestPopupContent.messages';
import { FormValues, ResubmitRequestPopupContentProps } from './ResubmitRequestPopupContent.types';

const qa = bemFactory.qa('reqf-resubmit-request-popup');

export const ResubmitRequestPopupContent: FC<ResubmitRequestPopupContentProps> = memo((props) => {
    const { onSubmit } = props;

    const progress = useSelector(isLoading);
    const request = useSelector(requestSelector);
    const workflowName = selectors.template.getTemplateDisplayNameByCode(request.integrationCode) || messages.request;

    const form = useForm<FormValues>();

    const handleSubmit = form.handleSubmit((data) => {
        onSubmit({ commentText: data.comment || '' });
    });

    return (
        <Form form={form} onSubmit={handleSubmit} data-qa={qa()}>
            <Popup.Header
                title={messages.title({ workflowName })}
                actions={
                    <Button data-qa={qa('done-button')} progress={progress} color='blue80' type='submit'>
                        {messages.submitButton}
                    </Button>
                }
            />

            <Popup.Body>
                <Grid gap={24}>
                    <Text font='body' color='midnight70'>
                        {messages.description({ workflowName })}
                    </Text>

                    <Text font='body' color='midnight70'>
                        {messages.note({ workflowName })}
                    </Text>

                    <TextField
                        qa={qa('comment-editor')}
                        label={messages.comment}
                        placeholder={messages.commentPlaceholder}
                        name={commentFieldName}
                        initFocus
                        multiline
                        rows={5}
                    />
                </Grid>
            </Popup.Body>
        </Form>
    );
});

ResubmitRequestPopupContent.displayName = 'ResubmitRequestPopupContent';
